import { render, staticRenderFns } from "./WorkerActivity.vue?vue&type=template&id=48bc88c4&"
import script from "./WorkerActivity.vue?vue&type=script&lang=js&"
export * from "./WorkerActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports